
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { AgencyRelationshipPricing } from '../../global/models/agency-relationship-pricing.model'
import AdditionalOptionsBreakdown from './AdditionalOptionsBreakdown.vue'

@Component({
  components: { AdditionalOptionsBreakdown }
})
export default class RelationshipSplitDisplay extends Vue {
  @Prop({ type: String, default: 'Label' })
  private readonly label!: string

  @Prop({ type: Number, default: null })
  private readonly percentage!: number

  @Prop({ type: Object, required: true })
  private readonly pricing!: AgencyRelationshipPricing

  private get sliderCents() {
    return this.pricing.default.provider
  }

  private get inverseSliderCents() {
    return this.pricing.default.agency
  }

  private get additionalOptions() {
    return this.pricing.additional || []
  }

  private get hasAdditionalOptions() {
    return this.additionalOptions.length > 0
  }
}
